import PresupuestoService from 'src/modules/presupuesto/presupuestoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';
import PresupuestoListActions from 'src/modules/presupuesto/list/presupuestoListActions';

const prefix = 'PRESUPUESTO_FORM';

const presupuestoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: presupuestoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await PresupuestoService.find(id);
      }

      dispatch({
        type: presupuestoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: presupuestoFormActions.INIT_ERROR,
      });

      getHistory().push('/presupuesto');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: presupuestoFormActions.CREATE_STARTED,
      });

      await PresupuestoService.create(values);

      dispatch({
        type: presupuestoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.presupuesto.create.success'),
      );

      // getHistory().push('/presupuesto');
      dispatch(
        PresupuestoListActions.doFetchCurrentFilter(),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: presupuestoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: presupuestoFormActions.UPDATE_STARTED,
      });

      await PresupuestoService.update(id, values);

      dispatch({
        type: presupuestoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.presupuesto.update.success'),
      );

      // getHistory().push('/presupuesto');
      dispatch(
        PresupuestoListActions.doFetchCurrentFilter(),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: presupuestoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default presupuestoFormActions;
